import React, { Fragment, useRef } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import FormApprovalPromo from "../../components/unapproved-promo/FormApproval";
import { updateModalContent, toggleModal } from "../../actions/modal";

const Approval = ({
    updateModalContent,
    toggleModal,
    unapproved_promo: { remainPromo }
}) => {
    const formApproval = useRef();

    const onRejectPromo = () => {
        updateModalContent({
            title: "Are you sure?",
            content: "This promo will be rejected.",
            actionButton: {
                actionText: "Yes, Reject!",
                actionType: "danger",
                action: () => formApproval.current.onRejectPromo()
            },
            cancelText: "No",
            closeAfterAction: true
        });

        toggleModal();
    };

    return (
        <Fragment>
            <div className="content-header">
                <h1>Unapproved Promo</h1>
            </div>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h4>Accept/Reject Promo</h4>
                    <div>
                        <Link to="/admin/unapproved-promo">
                            <button className="btn btn-secondary float-right">
                                Cancel
                            </button>
                        </Link>
                        {remainPromo ? (
                            <button
                                className="btn btn-danger float-right mr-1"
                                onClick={() => onRejectPromo()}
                            >
                                Reject
                            </button>
                        ) : (
                            <button
                                className="btn btn-danger float-right mr-1"
                                onClick={() => onRejectPromo()}
                                disabled
                            >
                                Reject
                            </button>
                        )}
                    </div>
                </div>
                <div className="card-body">
                    <FormApprovalPromo ref={formApproval} />
                </div>
            </div>
        </Fragment>
    );
};

Approval.postTypes = {
    unapproved_promo: PropTypes.object.isRequired,
    updateModalContent: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    unapproved_promo: state.admin.unapproved_promo
});

export default connect(mapStateToProps, {
    toggleModal,
    updateModalContent
})(Approval);
